import { TITLE } from '../../common/constants';
import type { SortDirection, Status } from '../../common/types';

export const PAGE_LIMIT = 25;
export const DEFAULT_SORT_KEY = TITLE;
export const DEFAULT_SORT_DIRECTION: SortDirection = 'ASC';
export const DEFAULT_STATUS: Status = 'archived';

export const NO_JSW_ACCESS_FOR_USER = 'no-jira-software-access-for-user';
export const PLAN_DIRECTORY_ERROR_FLAG_ID = 'plan-directory-error';
